import axios from 'axios';
import merge from 'lodash/merge';
import humps from 'humps';
import * as Sentry from '@sentry/browser';

import Config from '@/config';

// Exceptions
import {
  Unauthorized,
  BadRequest,
  UnknownError,
  NetworkError,
} from './exceptions';

const API_URL = Config.get('API_URL');

const client = axios.create({
  baseURL: API_URL,
  timeout: 5e4,
  transformResponse: [data => (data ? humps.camelizeKeys(JSON.parse(data)) : {})],
});

const resopnseErrorInterceptor = (error) => {
  Sentry.addBreadcrumb({
    message: error?.message,
    data: Object.entries(error?.response || {}).reduce(
      (obj, [key, value]) => ({ ...obj, [key]: JSON.stringify(value) }),
      {}
    ),
    category: 'xhr',
  });

  const message = error?.response?.data?.message;
  const status = error?.response?.status;

  let exception = do {
    if(status === 401) new Unauthorized(message);
    else if(status === 400) new BadRequest(message || 'La petición no ha podido ser procesada')
    else if (error?.response) new UnknownError(message || 'Algo ha salido mal')
    else new NetworkError('Error al establecer conexión con el servidor');
  };

  Sentry.captureException(exception);

  return Promise.reject(exception);
};

client.interceptors.response.use(response => response, resopnseErrorInterceptor);

const setHeaders = headers => merge(client.defaults.headers, headers);

export default {
  headers: setHeaders,
  post: client.post,
  put: client.put,
  patch: client.patch,
  get: client.get,
  delete: client.delete,
};
